module.exports = "https://cdn.schoolblocks.com/assets/_next/static/media/icon_2_form_x32-fd732.png";